import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const selfServiceModule = {
  state,
  mutations,
  actions,
  getters,
};

export default selfServiceModule;
